'use strict';
import Config from '../Config';
import {getItemWithExpiry, setItemWithExpiry} from '../utilities/localStorageUtils';
import {report, getReportParams} from '../middleware/report';

const CustomerTracking = (() => {
  const reportTracking = () => {
    try {
      let reportParams = getReportParams();
      reportParams.area = 'GeneralSite';
      reportParams.subArea = 'tracking';
      reportParams.channel = 'WebsitePrivate';
      reportParams.actionType = 'TrackingId targeted email/sms';
      reportParams.status = 'Completed';
      reportParams.messageText = 'siteloading with ct parameter.';
      reportParams.subscriber = '';
      reportParams.param1 = 'WEBSITE';
      report(reportParams);
    } catch (ex) {
      // nothing to do
    }
  };

  const setTracking = () => {
    const query = new URLSearchParams(window.location.search);
    const trackingId = query.get('ct');
    if (trackingId != undefined && trackingId != null) {
      let item = getItemWithExpiry('trackingId');
      if (item === undefined || item != trackingId) {
        setItemWithExpiry('trackingId', trackingId, Config.customerTrackingExpiryTimeInDays);
        reportTracking();
      }
    }
  };

  return {
    setTracking: setTracking,
  };
})();

export default CustomerTracking;
